import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import RecurringExpenseItems
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseItems';

function RecurringExpenseGroup({ resource, RecurringExpenseItemComponent }) {
  const expenseItems = resource.attr('items').resources().list();

  return (
    <FDStack direction={'column'} spacing={2} alignItems={'flex-start'} {...dataAttrs('recurring-expense-group')}>
      <FDStack direction={'column'} spacing={2}>
        <Text
          variant="h3"
          color="primary"
          weight={'medium'}
          value={resource.attr('title')}
          align={'left'}
        />
        <Text
          variant="h5"
          color="primaryGray"
          weight={'medium'}
          value={resource.attr('subtitle')}
          lineHeight={'small'}
          align={'left'}
        />
      </FDStack>
      <RecurringExpenseItems items={expenseItems} RecurringExpenseItemComponent={RecurringExpenseItemComponent} />
    </FDStack>
  );
}

RecurringExpenseGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  RecurringExpenseItemComponent: PropTypes.object.isRequired,
};

RecurringExpenseGroup.defaultProps = {
};

export default RecurringExpenseGroup;
